import React from 'react';
import {
  StatusApprovedIcon,
  StatusPendingIcon,
  StatusRejectedIcon,
  StatusSkippedIcon,
} from '../FlairIcon/icons';
import { ApprovalRequestStatus } from 'server/src/apps/internal-shared/repositoriesShared/ApprovalRequestRepositoryBase';

export type Status = 'PENDING' | 'APPROVED' | 'REJECTED' | 'SKIPPED';

export type StatusIconProps = {
  status: Status | ApprovalRequestStatus;
};

const StatusIcon: React.FC<StatusIconProps> = ({ status }) => {
  switch (status) {
    case 'PENDING':
      return <StatusPendingIcon data-testid={'status-pending-icon'} />;
    case 'APPROVED':
      return <StatusApprovedIcon data-testid={'status-approved-icon'} />;
    case 'REJECTED':
      return <StatusRejectedIcon data-testid={'status-rejected-icon'} />;
    case 'SKIPPED':
      return <StatusSkippedIcon data-testid={'status-skipped-icon'} />;
    default:
      return null;
  }
};

export default StatusIcon;
